import { toast } from "sonner"
import { getErrorMessage } from "./errors"

/**
 * Thin wrapper around sonner so every page reports errors the same way:
 * pass the caught error directly and it's formatted via getErrorMessage.
 * For a pre-formatted message (e.g. getPublishErrorMessage's output), pass a string.
 */
export function toastError(error: unknown): void {
  toast.error(typeof error === "string" ? error : getErrorMessage(error))
}

export function toastSuccess(message: string): void {
  toast.success(message)
}

export { toast }
